export default {
  retry: 'Réessayer',
  loadingErrorMessage:
    'Une erreur est survenue lors du chargement. Veuillez réessayer.',
};
